import type {
    IPersonaFit,
    IWeightedPersona,
} from '@experiences/interfaces';

import {
    PRIMARY_FIT_WEIGHT,
    SECONDARY_FIT_WEIGHT,
} from './Constants';
import { getPersonaFromBundleCode } from './GetPersonaFromBundleCode';

export function getPersonaFit(primaryBundleCodes: string[], secondaryBundleCodes: string[]): IPersonaFit {
    const weightedPersonas: IWeightedPersona[] = [
        {
            persona: 'UNKNOWN',
            weight: 0,
        },
    ];

    primaryBundleCodes?.forEach((bundleCode) => {
        const persona = getPersonaFromBundleCode(bundleCode);
        const existingPersona = weightedPersonas.find((wp) => wp.persona === persona);
        if (!existingPersona) {
            weightedPersonas.push({
                persona,
                weight: PRIMARY_FIT_WEIGHT,
            });
        }
    });

    secondaryBundleCodes?.forEach((bundleCode) => {
        const persona = getPersonaFromBundleCode(bundleCode);
        const existingPersona = weightedPersonas.find((wp) => wp.persona === persona);
        if (!existingPersona) {
            weightedPersonas.push({
                persona,
                weight: SECONDARY_FIT_WEIGHT,
            });
        }
    });

    weightedPersonas.sort((a, b) => b.weight - a.weight);

    weightedPersonas.forEach((wp) => {
        wp.weight = Math.round(wp.weight * 100) / 100;
    });

    return { fit: weightedPersonas };
}
